import { Col, Glyphicon, Grid, Row, Table } from 'react-bootstrap'

import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'
import { getRoundedNumber } from './DataCollection/DataCollectionHelper'

/**
 * React component which renders a table depicting the selected frames and associated cumputed values such as I0, Rg, Mass and a link to download the data.
 */
class SaxsHPLCSummaryTable extends React.Component {
  render() {
    if (this.props.frames && this.props.frames.length > 0) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12} md={12}>
              <Table>
                <thead>
                  <tr>
                    <th>Frame</th>
                    <th>I0</th>
                    <th>Rg</th>
                    <th>Mass</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.frames.map(frame => (
                    <tr key={frame.frameId}>
                      <td>{frame.frameId}</td>
                      <td> {getRoundedNumber(frame.I0, 1, false)} </td>
                      <td> {getRoundedNumber(frame.rg, 1, false)} </td>
                      <td> {getRoundedNumber(frame.mass, 1, false)} </td>
                      <td>
                        <Link to={frame.downloadUrl} style={{ cursor: 'pointer' }}>
                          <Glyphicon glyph="download" style={{ fontSize: '14px' }} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
      )
    }
    return null
  }
}

export default SaxsHPLCSummaryTable

SaxsHPLCSummaryTable.propTypes = {
  /** selected frames */
  frames: PropTypes.object,
}
